import React from "react";
import { Box, Divider, Grid2, IconButton, Typography } from "@mui/material";

// import s2tLogo from "../../Images/s2tlogo.png";
import { commonCss } from "../../CssStyle/commonCss";
import { Facebook, Instagram, LinkedIn, Twitter } from "@mui/icons-material";
import XIcon from "@mui/icons-material/X";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const origin = window.location.origin;
  return (
    <Grid2
      container
      justifyContent={"center"}
      sx={{ backgroundColor: "#0A66C2" }}
    >
      <Grid2
        container
        spacing={"1.5rem"}
        sx={{
          padding: { xs: "1rem", md: "1.5rem" },
          maxWidth: { xs: "auto", xl: "2000px" },
        }}
      >
        <Grid2
          size={12}
          container
          sx={{ backgroundColor: "transparent" }}
          spacing={"1.5rem"}
        >
          <Grid2 size={12}>
            <Box
              sx={{
                width: "100%",
                flexDirection: { xs: "column", sm: "row" },
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  color: commonCss.navCompanyNameColor,
                  gap: "0.5rem",
                  justifyContent: { xs: "center", md: "flex-start" },
                  alignItems: "flex-end",
                  width: { xs: "100%", md: "80%" },
                    cursor:"pointer"
                }}
                onClick={()=>{navigate("/")}}
              >
                <img
                  src={"/Images/s2tlogo.png"}
                  alt="s2tlogo"
                  style={{ width: "auto", height: "9vh" }}
                />
                <Typography variant="h6" sx={{ color: "inherit", mb: -0.8 }}>
                  SOLVER THOUGHTS TECHNOLOGIES
                </Typography>
              </Box>
              <Box
                sx={{
                  width: { xs: "100%", md: "20%" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: { xs: "center", md: "flex-end" },
                  gap: "1rem",
                }}
              >
                <IconButton
                  aria-label="LinkedIn"
                  sx={{
                    ":hover": {
                      color: commonCss.orange,
                      border: 1,
                      borderColor: commonCss.blue,
                    },
                    color: commonCss.white,
                  }}
                  onClick={() => {
                    window.open(
                      "https://www.linkedin.com/company/solverthoughts",
                      "_blank"
                    );
                  }}
                >
                  <LinkedIn sx={{ fontSize: commonCss.iconSize }} />
                </IconButton>
                <IconButton
                  aria-label="Facebook"
                  sx={{
                    ":hover": {
                      color: commonCss.orange,
                      border: 1,
                      borderColor: commonCss.blue,
                    },
                    color: commonCss.white,
                  }}
                  onClick={() => {
                    window.open(
                      "https://www.facebook.com/solverthoughts",
                      "_blank"
                    );
                  }}
                >
                  <Facebook sx={{ fontSize: commonCss.iconSize }} />
                </IconButton>
                <IconButton
                  aria-label="X (Twitter)"
                  sx={{
                    ":hover": {
                      color: commonCss.orange,
                      border: 1,
                      borderColor: commonCss.blue,
                    },
                    color: commonCss.white,
                  }}
                  onClick={() => {
                    window.open("https://x.com/Solverthoughts", "_blank");
                  }}
                >
                  {" "}
                  <XIcon sx={{ fontSize: commonCss.iconSize }} />
                </IconButton>

                <IconButton
                  aria-label="Instagram"
                  sx={{
                    ":hover": {
                      color: commonCss.orange,
                      border: 1,
                      borderColor: commonCss.blue,
                    },
                    color: commonCss.white,
                  }}
                >
                  <Instagram sx={{ fontSize: commonCss.iconSize }} />
                </IconButton>
              </Box>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 6, md: 3 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: commonCss.titleWeight,
                  position: "relative",
                  pt: "15px",
                  "::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "20%",
                    height: "3px",
                    backgroundColor: commonCss.orange,
                  },
                }}
              >
                Company
              </Typography>

              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  cursor: "pointer",
                  width: "fit-content",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
                onClick={() => {
                  navigate("/aboutus");
                }}
              >
                About Us
              </Typography>
              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  cursor: "pointer",
                  width: "fit-content",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
              >
                Blog
              </Typography>
              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  cursor: "pointer",
                  width: "fit-content",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
                onClick={() => {
                  window.open(`${origin}/policy`, "_blank");
                }}
              >
                Privacy Policy
              </Typography>
              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  cursor: "pointer",
                  width: "fit-content",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
                onClick={() => {
                  window.open(`${origin}/terms`, "_blank");
                }}
              >
                Terms and Conditions
              </Typography>
              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  cursor: "pointer",
                  width: "fit-content",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
                onClick={() => {
                  navigate("/faq");
                }}
              >
                FAQ
              </Typography>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 6, md: 3 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: commonCss.titleWeight,
                  position: "relative",
                  pt: "15px",
                  "::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "20%",
                    height: "3px",
                    backgroundColor: commonCss.orange,
                  },
                }}
              >
                Our Solutions
              </Typography>

              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  cursor: "pointer",
                  width: "fit-content",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
                onClick={() => {
                  navigate("/services");
                }}
              >
                Services
              </Typography>
              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  cursor: "pointer",
                  width: "fit-content",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
                onClick={() => {
                  navigate("/products");
                }}
              >
                Products
              </Typography>
              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  cursor: "pointer",
                  width: "fit-content",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
              >
                Demo
              </Typography>
              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  cursor: "pointer",
                  width: "fit-content",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
                onClick={() => {
                  navigate("/hrdf");
                }}
              >
                HRDF Training
              </Typography>
              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  cursor: "pointer",
                  width: "fit-content",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
                onClick={() => {
                  navigate("/outsourcing");
                }}
              >
                Outsourcing
              </Typography>
              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  cursor: "pointer",
                  width: "fit-content",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
              >
                Pricing
              </Typography>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: commonCss.titleWeight,
                  position: "relative",
                  pt: "15px",
                  "::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "20%",
                    height: "3px",
                    backgroundColor: commonCss.orange,
                  },
                }}
              >
                Join Us
              </Typography>

              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  cursor: "pointer",
                  width: "fit-content",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
              >
                Career
              </Typography>
              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  cursor: "pointer",
                  width: "fit-content",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
                // onClick={()=>{navigate('info@solverthoughts.com')}}
              >
                jobs@solverthoughts.com
              </Typography>
              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  width: "fit-content",
                  //   cursor: "pointer",
                  //   ":hover": {
                  //     color: commonCss.blue,
                  //   },
                }}
              >
                +60 3-2276 6982
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                mt: "1.5rem",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: commonCss.titleWeight,
                  position: "relative",
                  pt: "15px",
                  "::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "20%",
                    height: "3px",
                    backgroundColor: commonCss.orange,
                  },
                }}
              >
                Become a Partner
              </Typography>

              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  cursor: "pointer",
                  width: "fit-content",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
              >
                Partners
              </Typography>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: commonCss.titleWeight,
                  position: "relative",
                  pt: "15px",
                  "::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    width: "20%",
                    height: "3px",
                    backgroundColor: commonCss.orange,
                  },
                }}
              >
                Reach Us
              </Typography>

              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  width: "fit-content",
                  cursor: "pointer",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
              >
                Contact Us
              </Typography>
              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  width: "fit-content",
                  cursor: "pointer",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
              >
                Solver Thoughts Technologies Sdn Bhd <br />
                BO1-A-09-01, MENARA 2, KL ECO CITY , 3, Jln BANGSAR 59200 KUALA
                LUMPUR MALAYSIA
              </Typography>
              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  cursor: "pointer",
                  width: "fit-content",
                  ":hover": {
                    color: commonCss.orange,
                  },
                }}
                // onClick={()=>{navigate('info@solverthoughts.com')}}
              >
                info@solverthoughts.com
              </Typography>
              <Typography
                sx={{
                  fontWeight: commonCss.listWeight,
                  color: commonCss.listColor,
                  //   cursor: "pointer",
                  width: "fit-content",
                  //   ":hover": {
                  //     color: commonCss.blue,
                  //   },
                }}
              >
                +60 11-6575 8595
              </Typography>
            </Box>
          </Grid2>
        </Grid2>
        <Grid2 size={12}>
          <Divider
            sx={{
              borderStyle: "dotted",
              borderWidth: "2px",
              borderColor: "#B8B8B8",
            }}
          />
          <Box sx={{ width: "100%", pt: "1rem" }}>
            <Typography textAlign={"center"} sx={{ color: "#B8B8B8" }}>
              © {new Date().getFullYear()}, Solver Thoughts Technologies. All
              rights reserved
            </Typography>
          </Box>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default Footer;
